"use client"

import { ReactNode, useRef } from "react"
import styles from "./tooltip.module.css"

type Props = {
  tooltip: ReactNode
  children: ReactNode
}
const Tooltip = ({ tooltip, children }: Props) => {
  const ref = useRef(null)
  return (
    <div ref={ref} className={styles.tooltip}>
      <div className={styles.text}>
        {tooltip}
      </div>
      {children}
    </div>
  )
}

export default Tooltip